(function () {
  'use strict';

  var canAdopt =
    typeof CSSStyleSheet === 'function' &&
    typeof Document !== 'undefined' &&
    'adoptedStyleSheets' in Document.prototype;
  if (!canAdopt) return;

  // snippets/icon-user.liquid, currentColor swapped for black so the mask's
  // alpha is opaque (currentColor does not inherit into a mask image).
  var ICON =
    "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='12' cy='8' r='4.25'/%3E%3Cpath d='M4.25 20.25c0-3.7 3.47-6.25 7.75-6.25s7.75 2.55 7.75 6.25'/%3E%3C/svg%3E\")";

  var CSS = [
    /* The photo, the initials fallback, and the Shop-customer coin faces that
       wrap them. Hiding the coins as well as their contents matters: the
       avatar box is a centring flex container, so an empty-but-present coin
       would sit beside the glyph and push it off centre. */
    '.account-button__avatar-image,',
    '.account-button__avatar-initials,',
    '.account-button__coin-front,',
    '.account-button__coin-back { display: none !important; }',

    /* Strip the circular chrome: fill, inset ring, the ::before drop shadow,
       and the 3D context the Shop-customer variant sets up. */
    '.account-button__avatar {',
    '  background: none !important;',
    '  background-color: transparent !important;',
    '  box-shadow: none !important;',
    '  border: 0 !important;',
    '  transform: none !important;',
    '  transform-style: flat !important;',
    '  backface-visibility: visible !important;',
    '  color: inherit !important;',
    '}',
    '.account-button__avatar::before { display: none !important; content: none !important; }',

    '.account-button__avatar::after {',
    '  content: "" !important;',
    '  display: block !important;',
    '  width: 24px !important;',
    '  height: 24px !important;',
    '  background-color: currentColor !important;',
    '  background-image: none !important;',
    '  -webkit-mask: ' + ICON + ' center / 24px 24px no-repeat !important;',
    '  mask: ' + ICON + ' center / 24px 24px no-repeat !important;',
    '  position: static !important;',
    '  inset: auto !important;',
    '  z-index: auto !important;',
    '  transform: none !important;',
    '  animation: none !important;',
    '  opacity: 1 !important;',
    '}'
  ].join('\n');

  var sheet = new CSSStyleSheet();
  sheet.replaceSync(CSS);
  var watched = new WeakSet();

  function ensure(root) {
    var list = root.adoptedStyleSheets;
    if (list.indexOf(sheet) === -1) root.adoptedStyleSheets = list.concat(sheet);
  }

  function apply(root) {
    ensure(root);
    if (watched.has(root) || typeof MutationObserver !== 'function') return;
    watched.add(root);
    new MutationObserver(function () { ensure(root); }).observe(root, { childList: true, subtree: true });
  }

  function sweep() {
    document.querySelectorAll('shopify-account').forEach(function (host) {
      if (host.shadowRoot) apply(host.shadowRoot);
    });
  }

  [0, 300, 1000, 3000].forEach(function (delay) { setTimeout(sweep, delay); });
  document.addEventListener('shopify-render', sweep);

  if (typeof MutationObserver === 'function') {
    var seen = 0;
    var mo = new MutationObserver(function () {
      sweep();
      if (++seen > 40) mo.disconnect();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }
})();
